<template lang='slm'>
  .d-flex.align-items-center
    button.btn.btn-outline-primary type='button' @click='changeModalImage' Загрузить
    span.ml-3 v-show='modalUploadProgress' Загрузка {{ modalUploadProgress }}%
</template>

<script>
import $ from 'jquery';

export default {
  name: 'AdminFileUploader',
  props: {
    value: {
      required: true,
      validator: prop => typeof prop === 'number' || prop === null,
    },
  },
  data() {
    return {
      modalUploadProgress: 0,
    };
  },
  methods: {
    changeModalImage() {
      const input = document.createElement('input');
      input.type = 'file';
      $(input).on('change', () => {
        if (!input.files.length) return;
        const file = input.files[0];
        this.processFileFromInput(file);
      });
      input.click();
    },
    processFileFromInput(file) {
      this.$emit('fileSelected', file);
      const formData = new FormData();
      formData.append('file', file);
      $.ajax({
        url: `${document.location.origin}/api/file`,
        method: 'POST',
        data: formData,
        contentType: false,
        processData: false,
        xhr: () => {
          const xhr = new window.XMLHttpRequest();
          xhr.upload.addEventListener('progress', (evt) => {
            if (evt.lengthComputable) {
              const percentComplete = 100 * (evt.loaded / evt.total);
              if (percentComplete === 100) {
                this.modalUploadProgress = 0;
              } else {
                this.modalUploadProgress = Math.floor(percentComplete);
              }
            }
          }, false);
          return xhr;
        },
        success: (res) => {
          const uploadedFile = JSON.parse(res);
          this.$emit('input', uploadedFile.id);
        },
      });
    },
  },
};
</script>
